<script setup lang="ts">
import type { ApiBlockGridArea, ElementItem } from "@edco/apollo";
import type { BlockGridLayout_21Columns } from "~/models/generated/BlockGridLayout_21Columns";
import BaseColumnLayout, { type ColumnAlignment } from "~/components/common/BaseColumnLayout.vue";

const props = defineProps<{
  content: ElementItem<BlockGridLayout_21Columns>,
  areas: ApiBlockGridArea[],
  settings?: ElementItem
}>();
</script>

<template>
  <BaseColumnLayout
    :areas="areas"
    :theme="settings?.properties.blockTheme"
    :left-column-alignment="settings?.properties.leftColumnAlignment?.toLowerCase() as ColumnAlignment"
    :right-column-alignment="settings?.properties.rightColumnAlignment?.toLowerCase() as ColumnAlignment"
    :no-top-padding="settings?.properties.noTopPadding"
    :no-bottom-padding="settings?.properties.noBottomPadding"
    layout-class="two-one-column" />
</template>
